<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="用户">
<!--                  <el-input  v-model="queryForm.userId"></el-input>-->
                  <GridSelectU style="width: 177px;" labelName="userName"
                               labelValue="id" title="选择用户" :value="queryForm.userId" :limit='1' size='small' placeholder='请选择用户'
                               @getValue="getSearchValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
                  </GridSelectU>
              </el-form-item>
              <el-form-item label="店铺">
<!--                  <el-input  v-model="queryForm.storeId"></el-input>-->
                  <GridSelectLi
                      style="width: 177px"
                      title="选择门店"
                      labelName="storeName"
                      labelValue="id"
                      :value="queryForm.storeId"
                      :limit="1"
                      size="small"
                      placeholder="请选择门店"
                      @getValue="getSearchValueStoreId"
                      :columns="STORE_code"
                      :searchs="STORE_search"
                      dataListUrl="/shop/store/findList"
                      entityBeanName="shopStore"
                      queryEntityUrl="/shop/store/get"
                  >
                  </GridSelectLi>
              </el-form-item>
              <el-form-item label="当天日期">
<!--                  <el-input  v-model="queryForm.dayDate"></el-input>-->
                  <el-date-picker
                      style="width: 177px;"
                      size="small"
                      v-model="queryForm.dayDate"
                      type="date"
                      value-format="yyyy-MM-dd"
                      placeholder="选择日期">
                  </el-date-picker>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getOperationDailyStorePlusList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addOperationDailyStorePlus"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editOperationDailyStorePlus(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteOperationDailyStorePlus(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshOperationDailyStorePlusList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="operationDailyStorePlusList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="userId"
        label="用户"
        width="180"
      >
          <template slot-scope="scope">
              <div v-if="scope.row.user">
                  <div style="text-align: left">账号：{{ scope.row.user.userName }}</div>
                  <div style="text-align: left">手机：{{ scope.row.user.userMobile }}</div>
                  <div style="text-align: left">昵称：{{ scope.row.user.userNickname }}</div>
                  <div style="text-align: left">姓名：{{ scope.row.user.userRealname }}</div>
              </div>
              <div v-else>--</div>
          </template>
      </el-table-column>
      <!--el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="storeId"
        label="店铺"
        width="180"
      ></el-table-column-->
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="dayDate"
        label="当天日期"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="currentScore"
        label="当时拥有的悦果"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="isSend"
        label="是否已发放"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="totalScore"
        label="结算时总的悦果"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="totalMoney"
        label="结算时总的应该发放的抵扣券"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="sendMoney"
        label="放发抵扣券数量"
        width="180"
      > </el-table-column>
        <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkOperationDailyStorePlus(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editOperationDailyStorePlus(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteOperationDailyStorePlus(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="operationDailyStorePlusStates[operationDailyStorePlusState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="operationDailyStorePlus"
          ref="operationDailyStorePlusForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="用户"
            prop="userId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="operationDailyStorePlus.userId"-->
<!--              :disabled="operationDailyStorePlusState == 'check'"-->
<!--            ></el-input>-->
              <GridSelectU style="width: 177px;" labelName="userName"
                           labelValue="id" title="选择用户" :value="operationDailyStorePlus.userId" :limit='1' size='small' placeholder='请选择用户' :disabled="operationDailyStorePlusState == 'check'"
                           @getValue="getValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
              </GridSelectU>
          </el-form-item>
          <el-form-item
            label="店铺"
            prop="storeId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="operationDailyStorePlus.storeId"-->
<!--              :disabled="operationDailyStorePlusState == 'check'"-->
<!--            ></el-input>-->
              <GridSelectLi
                  style="width: 177px"
                  title="选择门店"
                  labelName="storeName"
                  labelValue="id"
                  :value="operationDailyStorePlus.storeId"
                  :disabled="operationDailyStorePlusState == 'check'"
                  :limit="1"
                  size="small"
                  placeholder="请选择门店"
                  @getValue="getValueStoreId"
                  :columns="STORE_code"
                  :searchs="STORE_search"
                  dataListUrl="/shop/store/findList"
                  entityBeanName="shopStore"
                  queryEntityUrl="/shop/store/get"
              >
              </GridSelectLi>
          </el-form-item>
          <el-form-item
            label="当天日期"
            prop="dayDate"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="operationDailyStorePlus.dayDate"-->
<!--              :disabled="operationDailyStorePlusState == 'check'"-->
<!--            ></el-input>-->
              <el-date-picker
                  style="width: 177px;"
                  size="small"
                  :disabled="operationDailyStorePlusState == 'check'"
                  v-model="operationDailyStorePlus.dayDate"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期">
              </el-date-picker>
          </el-form-item>
          <el-form-item
            label="当时拥有的悦果"
            prop="currentScore"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="operationDailyStorePlus.currentScore"
              :disabled="operationDailyStorePlusState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="是否已发放"
            prop="isSend"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="operationDailyStorePlus.isSend"-->
<!--              :disabled="operationDailyStorePlusState == 'check'"-->
<!--            ></el-input>-->
              <el-select
                  clearable
                  style="width: 177px"
                  v-model="operationDailyStorePlus.isSend"
                  :disabled="operationDailyStorePlusState == 'check'"
                  placeholder="请选择"
                  size="small"
              >
                  <el-option label="已发放" :value="1"></el-option>
                  <el-option label="未发放" :value="0"></el-option>
              </el-select>
          </el-form-item>
          <el-form-item
            label="结算时总的悦果"
            prop="totalScore"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="operationDailyStorePlus.totalScore"
              :disabled="operationDailyStorePlusState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="结算时总的应该发放的抵扣券"
            prop="totalMoney"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="operationDailyStorePlus.totalMoney"
              :disabled="operationDailyStorePlusState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="放发抵扣券数量"
            prop="sendMoney"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="operationDailyStorePlus.sendMoney"
              :disabled="operationDailyStorePlusState == 'check'"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="operationDailyStorePlusState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import GridSelectU from '@/components/gridselect/index.vue';
import GridSelectLi from '@/components/gridselect/gidselect.vue';
import { STORE, STORE_SEARCH, USER, USER_SEARCH } from '@/utils/constant';

export default {
    components: {
        GridSelectLi,
        GridSelectU,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetOperationDailyStorePlusList();
                    this.getOperationDailyStorePlusList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetOperationDailyStorePlusList();
                    this.getOperationDailyStorePlusList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     userId: '', //用户
                     storeId: '', //店铺
                     dayDate: '', //当天日期
                     currentScore: '', //当时拥有的悦果
                     isSend: '', //是否已发放
                     totalScore: '', //结算时总的悦果
                     totalMoney: '', //结算时总的应该发放的抵扣券
                     sendMoney: '', //放发抵扣券数量
                },
                STORE_code: STORE,
                STORE_search: STORE_SEARCH,
                USER_code: USER,
                USER_search: USER_SEARCH,
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                operationDailyStorePlusState: 'add',
                operationDailyStorePlusStates: {
                    add: '新建悦果分配池',
                    check: '查看悦果分配池',
                    edit: '修改悦果分配池'
                },

                multipleSelection: [],
                operationDailyStorePlusList: [],
                operationDailyStorePlus: {
                    id: '', //
                    userId: '', //用户
                    storeId: '', //店铺
                    dayDate: '', //当天日期
                    currentScore: '', //当时拥有的悦果
                    isSend: '', //是否已发放
                    totalScore: '', //结算时总的悦果
                    totalMoney: '', //结算时总的应该发放的抵扣券
                    sendMoney: '', //放发抵扣券数量
                },
                btnLoading: false,

                rules: {
                    userId: [{ required: true, message: '用户不能为空', trigger: 'blur' }],
                    storeId: [{ required: true, message: '店铺不能为空', trigger: 'blur' }],
                    dayDate: [{ required: true, message: '当天日期不能为空', trigger: 'blur' }],
                    currentScore: [{ required: true, message: '当时拥有的悦果不能为空', trigger: 'blur' }],
                    isSend: [{ required: true, message: '是否已发放不能为空', trigger: 'blur' }],
                    totalScore: [{ required: true, message: '结算时总的悦果不能为空', trigger: 'blur' }],
                    totalMoney: [{ required: true, message: '结算时总的应该发放的抵扣券不能为空', trigger: 'blur' }],
                    sendMoney: [{ required: true, message: '放发抵扣券数量不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {
            this.getOperationDailyStorePlusList();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            getValueUser(value){
                this.operationDailyStorePlus.userId = value
            },
            getSearchValueUser(value){
                this.queryForm.userId = value
            },
            getValueStoreId(value){
                this.operationDailyStorePlus.storeId = value
            },
            getSearchValueStoreId(value){
                this.queryForm.storeId = value
            },
            resetOperationDailyStorePlusList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.operationDailyStorePlusList = [];
            },
            resetDialog() {
                this.operationDailyStorePlusState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      userId: '', //用户
                      storeId: '', //店铺
                      dayDate: '', //当天日期
                      currentScore: '', //当时拥有的悦果
                      isSend: '', //是否已发放
                      totalScore: '', //结算时总的悦果
                      totalMoney: '', //结算时总的应该发放的抵扣券
                      sendMoney: '', //放发抵扣券数量
                };
                this.getOperationDailyStorePlusList();
            },
            closeDialog() {
                this.showDialog = false
                this.operationDailyStorePlus = {
                      id: '', //
                      userId: '', //用户
                      storeId: '', //店铺
                      dayDate: '', //当天日期
                      currentScore: '', //当时拥有的悦果
                      isSend: '', //是否已发放
                      totalScore: '', //结算时总的悦果
                      totalMoney: '', //结算时总的应该发放的抵扣券
                      sendMoney: '', //放发抵扣券数量
                };
            },
            submitForm() {
                if (this.operationDailyStorePlusState == 'add') {
                    this.$refs.operationDailyStorePlusForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/operation/dailystoreplus/add`,{ ...this.operationDailyStorePlus }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetOperationDailyStorePlusList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.operationDailyStorePlusState == 'edit') {
                    this.$refs.operationDailyStorePlusForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            delete this.operationDailyStorePlus.user
                            post(`/operation/dailystoreplus/edit`,{ ...this.operationDailyStorePlus }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetOperationDailyStorePlusList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addOperationDailyStorePlus() {
                this.showDialog = true;
                this.operationDailyStorePlusState = 'add';
            },
            checkOperationDailyStorePlus(operationDailyStorePlusId) {
                console.log(operationDailyStorePlusId);
                this.currentOperationDailyStorePlusId = operationDailyStorePlusId;

                this.getOperationDailyStorePlusById();
                this.showDialog = true;
                this.operationDailyStorePlusState = 'check';
            },
            editOperationDailyStorePlus(operationDailyStorePlusId) {
                console.log('operationDailyStorePlus', operationDailyStorePlusId);
                if (operationDailyStorePlusId) {
                    this.currentOperationDailyStorePlusId = operationDailyStorePlusId;
                    this.getOperationDailyStorePlusById();
                } else {
                    this.operationDailyStorePlus = { ...this.operationDailyStorePlus, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.operationDailyStorePlusState = 'edit';
            },
            deleteOperationDailyStorePlus(operationDailyStorePlusId) {
                let ids = '';
                if (operationDailyStorePlusId) {
                    ids = operationDailyStorePlusId;
                } else {
                    ids = this.multipleSelection.map((operationDailyStorePlus) => operationDailyStorePlus.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/operation/dailystoreplus/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetOperationDailyStorePlusList();
                                this.getOperationDailyStorePlusList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshOperationDailyStorePlusList() {
                this.resetOperationDailyStorePlusList();
                this.getOperationDailyStorePlusList();
            },
            getOperationDailyStorePlusList(query = {}) {
                this.loading = true;
                get(`/operation/dailystoreplus/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.operationDailyStorePlusList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getOperationDailyStorePlusById() {
                get(`/operation/dailystoreplus/get`,{ id: this.currentOperationDailyStorePlusId }).then((res) =>{
                    if(res.success){
                      this.operationDailyStorePlus = { ...this.operationDailyStorePlus, ...res.operationDailyStorePlus };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportOperationDailyStorePlusList() {
                //this.btnLoading = true;
                exprotExcel(`/operation/dailystoreplus/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/operation/dailystoreplus/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/operation/dailystoreplus/importData`,formData);
              this.refreshOperationDailyStorePlusList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getOperationDailyStorePlusList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getOperationDailyStorePlusList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>